import { createVNode as o, mergeProps as l } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/QuestionCircleFilledStandard.js";
import n from "../components/PfIcon.js";
const r = (e, t) => {
  const i = {
    ...e,
    ...t.attrs
  };
  return o(n, l(i, {
    icon: a
  }), null);
};
r.displayName = "QuestionCircleFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
